import React from "react";
import {Container} from "react-bootstrap";
import {Link} from "react-router-dom";

export function QinGuanTitle() {
    return <h5 className="author-label"><Link to="/translation/qinguan">Qín Guān</Link></h5>
}

function QinGuan() {
    return (
        <Container>
            <QinGuanTitle/>
            <ul>
                <li><Link to="/translation/qinguan/chill-fog-lights">chill fog lights</Link></li>
            </ul>
            <div>
                <h5>References</h5>
                <ul>
                    <li><a href="https://en.wikipedia.org/wiki/Qin_Guan">Wiki</a></li>
                </ul>
            </div>
        </Container>
)
}

export default QinGuan;
